// import Vue from 'vue'
import Router from 'vue-router'
var width = $(window).width()
Vue.use(Router)
const router = new Router({
  mode: "history",
  routes: [
    {
      path: '/',
      name: 'Home',
      meta: {
        title: 'Nfc防伪查询'
      },
      component: (resolve) => {
        import('@components/Home.vue').then((module) => {
          resolve(module)
        })
      }
    },
    {
      path: '/queryRet',
      name: 'NfcDetail',
      meta: {
        title: '查询结果'
      },
      component: (resolve) => {
        import('@components/Nfc.vue').then((module) => {
          resolve(module)
        })
      }
    },
    {
      path: '/tb',
      name: 'Tb',
      meta: {
        title: '跳播'
      },
      component: (resolve) => {
        if (width < 500) {
          import('@components/Tbmobile.vue').then((module) => {
            resolve(module)
          })
        } else {
          import('@components/Tbweb.vue').then((module) => {
            resolve(module)
          })
        }
      }
    },
    {
      path: '/tbmobile',
      name: 'Tbmobile',
      meta: {
        title: '跳播'
      },
      component: (resolve) => {
        import('@components/Tbmobile.vue').then((module) => {
          resolve(module)
        })
      }
    },
    {
      path: '/tbweb',
      name: 'Tbweb',
      meta: {
        title: '跳播'
      },
      component: (resolve) => {
        import('@components/Tbweb.vue').then((module) => {
          resolve(module)
        })
      }
    },
    {
      path: '/tbtest',
      name: 'Tbtest',
      meta: {
        title: '跳播'
      },
      component: (resolve) => {
        if (width < 500) {
          import('@components/Tbtest.vue').then((module) => {
            resolve(module)
          })
        } else {
          import('@components/Tbtest2.vue').then((module) => {
            resolve(module)
          })
        }
      }
    },
    {
      path: '/tbtest2',
      name: 'Tbtest2',
      meta: {
        title: '跳播'
      },
      component: (resolve) => {
        import('@components/Tbtest2.vue').then((module) => {
          resolve(module)
        })
      }
    },
    {
      path: '/test',
      name: 'Test',
      meta: {
        title: '跳播'
      },
      component: (resolve) => {
        import('@components/Test.vue').then((module) => {
          resolve(module)
        })
      }
    },
    {
      path: '/tbnew',
      name: 'Tbnew',
      meta: {
        title: '跳播'
      },
      component: (resolve) => {
        import('@components/Tbnew.vue').then((module) => {
          resolve(module)
        })
      }
    },
    {
      path: '/tbnew2',
      name: 'Tbnew2',
      meta: {
        title: '跳播'
      },
      component: (resolve) => {
        import('@components/Tbnew2.vue').then((module) => {
          resolve(module)
        })
      }
    },
    {
      path: '/tbnew3',
      name: 'Tbnew3',
      meta: {
        title: '跳播'
      },
      component: (resolve) => {
        import('@components/Tbnew3.vue').then((module) => {
          resolve(module)
        })
      }
    },
    {
      path: '/tbtx',
      name: 'Tbtx',
      meta: {
        title: '跳播'
      },
      component: (resolve) => {
        if (width < 500) {
          import('@components/Tbtxmobile.vue').then((module) => {
            resolve(module)
          })
        } else {
          import('@components/Tbtx.vue').then((module) => {
            resolve(module)
          })
        }

      }
    },
    {
      path: '/tbtxmobile',
      name: 'Tbtxmobile',
      meta: {
        title: '跳播'
      },
      component: (resolve) => {
        import('@components/Tbtxmobile.vue').then((module) => {
          resolve(module)
        })
      }
    },
    {
      path: '/tbyk',
      name: 'Tbyk',
      meta: {
        title: '跳播'
      },
      component: (resolve) => {
        import('@components/Tbyk.vue').then((module) => {
          resolve(module)
        })
      }
    },
    {
      path: '/tbtxy',
      name: 'Tbtxy',
      meta: {
        title: '跳播'
      },
      component: (resolve) => {
        import('@components/Tbtxy.vue').then((module) => {
          resolve(module)
        })
      }
    },
    {
      path: '/login',
      name: 'Login',
      meta: {
        title: '登录'
      },
      component: (resolve) => {
        import('@components/Login.vue').then((module) => {
          resolve(module)
        })
      }
    },
    {
      path: '/loginweb',
      name: 'LoginWeb',
      meta: {
        title: '登录'
      },
      component: (resolve) => {
        import('@components/LoginWeb.vue').then((module) => {
          resolve(module)
        })
      }
    },
    {
      path: '/register',
      name: 'Register',
      meta: {
        title: '注册'
      },
      component: (resolve) => {
        import('@components/Register.vue').then((module) => {
          resolve(module)
        })
      }
    },
    {
      path: '/pay',
      name: 'Pay',
      meta: {
        title: '支付'
      },
      component: (resolve) => {
        import('@components/Pay.vue').then((module) => {
          resolve(module)
        })
      }
    },
    {
      path: '/payweb',
      name: 'PayWeb',
      meta: {
        title: '支付'
      },
      component: (resolve) => {
        import('@components/PayWeb.vue').then((module) => {
          resolve(module)
        })
      }
    },
    {
      path: '/mp3/tb',
      name: 'mp3/Tb',
      meta: {
        title: '支付'
      },
      component: (resolve) => {
        import('@components/mp3/Tb.vue').then((module) => {
          resolve(module)
        })
      }
    }
  ]
})

/**
 *@date: 2018-09-04 10:17:38
 *@author:
 *@desc: 路由全局钩子函数，可以做路由跳转拦截
 */
router.beforeEach((to, from, next) => {
  console.log('路由拦截')
  console.log(to.name)
  console.log(from.name)
  console.log(to.meta.title)
  if (to.meta.title) document.title = `${to.meta.title}`

  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js